import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "table-title"
}, "费率列表", -1);
const _hoisted_2 = {
  key: 0,
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_3 = {
  key: 1,
  style: {
    "padding": "0 10px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_table_page = _resolveComponent("table-page");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, null, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_table_page, {
    fetchApi: _ctx.$api.business.rechargePromotion.getList,
    columns: $data.columns,
    topButtons: $data.topButtons,
    linkButtons: $data.linkButtons,
    searchItems: $data.searchItems,
    selectionEnable: false,
    "row-key": "id",
    ref: "tablePage"
  }, {
    toolBarLeft: _withCtx(() => [_hoisted_1]),
    itemExpand: _withCtx(data => [data.data.items ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_table, {
      data: data.data.items,
      "row-class-name": "expand-row-class"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        label: "充值金额",
        prop: "fee",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        label: "赠送金额",
        prop: "giveFee",
        align: "center"
      })]),
      _: 2
    }, 1032, ["data"])])) : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($options.loadItems(data.data)), 1))]),
    _: 1
  }, 8, ["fetchApi", "columns", "topButtons", "linkButtons", "searchItems"])]);
}